import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDashboard } from "../../../services/api/reports/reportsApi";

export const fetchDashboardData = createAsyncThunk(
  "reports/fetchDashboardData",
  async (dateRange = {}, { rejectWithValue }) => {
    try {
      const response = await fetchDashboard(dateRange);
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch dashboard data");
    }
  },
);

const reportsSlice = createSlice({
  name: "reports",
  initialState: {
    dashboardData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default reportsSlice.reducer;
